import { Check, Trash2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { previewSpecs } from "./PreviewStage";

const stamp = (d) =>
  d ? new Date(d).toLocaleString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(",", "") : "";

export default function PreviewHistory({ previews, viewingId, onView, onDelete }) {
  if (previews.length === 0) return null;
  return (
    <section className="bg-card border border-border rounded-2xl p-4 sm:p-5" data-testid="ai-preview-history">
      <h2 className="text-sm text-muted-foreground mb-3">
        Preview History <span className="tabular-nums">({previews.length})</span>
      </h2>
      <div className="flex gap-3 overflow-x-auto pb-1 snap-x">
        {previews.map((p, idx) => {
          const n = previews.length - idx;
          const active = p._id === viewingId;
          const busy = p.status === "QUEUED" || p.status === "PROCESSING";
          return (
            <div key={p._id} className="relative group w-[15rem] sm:w-[17rem] shrink-0 snap-start">
              <button
                data-testid={`history-preview-${p._id}`}
                aria-pressed={active}
                onClick={() => onView(p._id)}
                className={cn(
                  "w-full text-left rounded-xl overflow-hidden border-2 transition-colors bg-card",
                  active ? "border-accent" : "border-border hover:border-foreground/25",
                )}
              >
                <span className="block aspect-[16/8] bg-secondary">
                  {p.status === "SUCCESS" && p.previewUrl ? (
                    <img src={p.previewUrl} alt={`Preview #${n}`} loading="lazy" className="h-full w-full object-cover" />
                  ) : (
                    <span className="h-full flex items-center justify-center text-xs text-muted-foreground">
                      {p.status === "FAILED" ? "Failed" : p.status === "SUCCESS" ? "No image" : "Generating…"}
                    </span>
                  )}
                </span>
                <span className="flex items-center gap-2 px-3 py-2">
                  <span className="text-xs font-medium text-foreground truncate flex-1">
                    #{n} {previewSpecs(p) || "—"}
                  </span>
                  {p.isSelectedFinal && <Check className="h-3.5 w-3.5 text-success shrink-0" aria-label="Final design" />}
                  <span className="text-[11px] text-muted-foreground shrink-0 tabular-nums">{stamp(p.createdAt)}</span>
                </span>
              </button>
              {/* Hidden while generating: the job would still write its result to a deleted record. */}
              {!busy && (
                <button
                  type="button"
                  aria-label={`Delete preview #${n}`}
                  data-testid={`delete-preview-button-${p._id}`}
                  onClick={() => onDelete(p._id)}
                  className="absolute top-2 right-2 rounded-full bg-card/95 p-1.5 text-muted-foreground shadow-sm opacity-100 sm:opacity-0 sm:group-hover:opacity-100 focus:opacity-100 hover:text-danger transition-opacity"
                >
                  <Trash2 className="h-3.5 w-3.5" />
                </button>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
